<template>
  <div class="new_product_release_div">
    <div class="right_content content_all">
      <div>
        <div v-if="tagList.length || key" class="right_search_div">
          <span>全部结果：</span>
          <div class="right_search_input">
            <div v-for="(item, index) in tagList" :key="index" class="right_search_input_info">
              <div class="right_search_input_tag">
                <strong>{{getTagName(item)}}:{{item.name}}</strong>
                <b @click="deleteTag(item)">x</b>
              </div>
              <span> &gt; </span>
            </div>
          </div>
          <span v-if="key" class="right_search_key">"{{key}}"<b @click="deleteSearchText">x</b></span>
        </div>
        <goods-search v-if="queryData.length" :queryData="queryData" @brandItemHandleClick="brandItemHandleClick" @handleClickProductItem="handleClickProductItem" @handleClickIndustryItem="handleClickIndustryItem"></goods-search>
      </div>
      <div class="brand_div">
          <div v-for="(item, index) in videoList" :key="index" class="brand_item">
              <div class="type_img_block_content">
                  <img :class="['logo-img', 'hide']" :src="baseUrl + item.brandImageUrl + '.png'" style={} >
<!--                  <img :src="baseUrl + item">-->
                  <el-image class="pic-item" :key="index" :src="item.imageUrl" :preview-src-list="[item.imageUrl]"></el-image>
              </div>
              <div class="type_img_block_title">
                  <span>{{item.pictureName || item.brandEnglishName}}</span>
                  <img class="active_bg" src="../assets/other/more3.png">
                  <img class="default_bg" src="../assets/other/more2.png">
              </div>
          </div>
<!--        <pic-list :videoList="videoList" @VideoHandleClick="VideoHandleClick"></pic-list>-->
        <div class="clear_both"></div>
<!--        <paging v-if="total > pageSize" :total="total" @handleCurrentChange="handleCurrentChange"></paging>-->
        <div style="display: flex; justify-content: center; align-items: center;">
            <button @click="openClick()" style="background-color: #0a4da2; color: white; padding: 12px 24px; font-size: 16px; border: none; border-radius: 4px; cursor: pointer;">查看详情</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { baseUrl } from '../utils'
import goodsSearch from './public/goodsSearch.vue'
import picList from './public/picList.vue'
import paging from './public/paging.vue'
import {GetPicList,GetPicGet} from "@/api/pdf/api";
export default {
  name: 'exhibitionPic',
  data() {
    return {
      searchList: {

      },
      fieldType: {
        brandType: '品牌',
        productType: '产品',
        industryType: '工业'
      },
      baseUrl,
      // 是否展示菜单
      menuShow: true,
      // 菜单列表
      menuDataList: [],
      // 产品总条数
      total: 0,
      // 产品列表
      videoList: [],
      // 当前页数
      currentPage: 1,
      // 每页条数
      pageSize: 20,
      // brand 品牌筛选
      brandId: 0,
      // 三级条件
      thirdCatId: 0,
      fourCatId: 0,
      // 产品分类
      productType: 0,
      subCatId: 0,
      // 产业分类
      industryType: 0,
      // 搜索文字
      key: '',
      // 筛选条件
      queryData: [],
      // 是否有搜索条件
      searching: false,
      // 条件列表
      tagList: [],
      itemId: 0,
      itemName: 0,
      industryFirstCatId: 0,
      industrySecordCatId: 0,
      companyId: '',
      imageDatas: []
    }
  },
  watch: {
    '$route.query.searchKey'(val){
      this.currentPage = 1;
      this.key = val || '';
      this.getPDFList();
    },
  },
  beforeDestroy() {
    this.$watch('$route.query.searchKey', () => {});
  },
  components: {
    goodsSearch,
    picList,
    paging
  },
  methods: {
    brandItemHandleClick(item) {
      item.key = 'brandId';
      item.level = 1;
      this.pushTagList(item);
      this.getPDFList();
      this.initPage();
    },
    handleClickProductItem(item) {
      item.key = 'productType';
      item.level = 2;
      if(item.fieldName === 'subCatId') {
        item.level = 2;
      } else if(item.fieldName === 'thirdCatId') {
        item.level = 3;
      } else if(item.fieldName === 'fourCatId') {
        item.level = 4;
      }
      this.pushTagList(item);
      this.getPDFList();
      this.initPage();
    },
    handleClickIndustryItem(item) {
      item.key = 'industryType';
      item.level = 5;
      if(item.fieldName === 'industryFirstCatId') {
        item.level = 5;
      } else if(item.fieldName === 'industrySecordCatId') {
        item.level = 6;
      }
      this.pushTagList(item);
      this.getPDFList();
      this.initPage();
    },
    VideoHandleClick(item) {


    },
      openClick() {
          this.$router.push({
              path: '/Pdf',
              query: {
                  pdfIdList: this.videoList[0].pdfIdList
              }
          });

      },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getPDFList();
    },
    getPDFList() {
      let { pictureShowId,imageDatas,id } = this.$route.query;
      if (id) {
          // 从sessionStorage中取出数据
          let jsonstr = sessionStorage.getItem('pic:' + id);
          if (jsonstr) {
              let data = JSON.parse(jsonstr);
              let letData = [];
              let split = data.imageUrlAll.split(',');
              for (let j = 0; j < split.length; j++) {
                  let udfData = {};
                  let img = split[j];
                  if (!img.startsWith("http")) {
                      img = "https://andrnd.com" + img;
                  }
                  udfData.imageUrl = img;
                  udfData.brandName = data.brandName;
                  if (!udfData.brandName) {
                      udfData.brandName = data.brandEnglishName;
                  }
                  udfData.pdfIdList = data.pdfIdList;
                  udfData.pictureName = data.pictureName;
                  udfData.brandImageUrl = data.brandImageUrl;
                  letData.push(udfData);
              }
              this.videoList = letData;
              this.total = data.total;
          }
      } else {
          GetPicList({
              pictureShowId: pictureShowId,
              'brandId': this.brandId,
              'industryFirstCatId': this.industryFirstCatId,
              'industrySecordCatId': this.industrySecordCatId,
              'thirdCatId': this.thirdCatId,
              'fourCatId': this.fourCatId,
              'subCatId': this.subCatId,
              'key': this.key,
              'pageNum': this.currentPage,
              'pageSize': this.pageSize,
              'companyId': this.companyId,
              'id': id,
          }).then(data => {
              let videoList = [...data.list];
              let letData = [];
              for (let i = 0; i < videoList.length; i++) {
                  let split = videoList[i].imageUrl.split(',');
                  for (let j = 0; j < split.length; j++) {
                      let udfData = {};
                      let img = split[j];
                      if (!img.startsWith("http")) {
                          img = "https://andrnd.com" + img;
                      }
                      udfData.imageUrl = img;
                      udfData.brandName = videoList[i].brandName;
                      if (!udfData.brandName) {
                          udfData.brandName = videoList[i].brandEnglishName;
                      }
                      udfData.pdfIdList = videoList[i].pdfIdList;
                      udfData.pictureName = videoList[i].pictureName;
                      udfData.brandImageUrl = videoList[i].brandImageUrl;
                      letData.push(udfData);
                  }
              }
              this.videoList = letData;
              this.total = data.total;
              data.queryData.forEach(item => {
                  let {data, name, type} = item;
                  data.length && data.forEach(dataItem => {
                      dataItem.fieldName = name;
                      dataItem.fieldType = type;
                  })
              });
              this.queryData = [...data.queryData];
          })
      }
    },
    pushTagList(item) {
      let tagList = [...this.tagList];
      tagList = tagList.filter(tag => (tag.level !== item.level));
      tagList.push(item);
      this[item.fieldName] = item.value;
      this.$nextTick(() => {
        tagList.sort((a, b) => {
          return a.level - b.level;
        });
        this.tagList = [...tagList];
      });
    },
    getTagName(item) {
      return this.fieldType[item.fieldType];
    },
    deleteTag(item) {
      this.deleteTagList(item);
      this.initValue(item.fieldType, item.fieldName);
      this.tagList.forEach(item => this[item.key] = item.value);
      this.getPDFList();
    },
    deleteTagList(item) {
      let tagList = this.tagList.filter(tag => {
        let {fieldType: type, fieldName, level} = item;
        if(type === 'brandType') {
          return tag.fieldType !== type;
          // return tag.level !== level;
        } else if(type === 'softType') {
          return tag.fieldType !== type;
        }
        else if(type === 'productType') {
          if(fieldName === 'subCatId') {
            return tag.fieldType !== type;
          } else if(fieldName === 'thirdCatId') {
            return tag.level !== level && tag.level !== 4;
          }
          return tag.level !== level;
        } else if(type === 'industryType') {
          if(fieldName === 'industryFirstCatId') {
            return tag.fieldType !== type;
          }
          return tag.level !== level;
        }
      });
      this.tagList = [...tagList];
    },
    initValue(type = 'all', fieldName) {
      this.currentPage = 1;
      if(type === 'all') {
        this.brandId = 0;
        this.softId = 0;
        this.subCatId = 0;
        this.thirdCatId = 0;
        this.fourCatId = 0;
        this.industryFirstCatId = 0;
        this.industrySecordCatId = 0;
        // this.key = '';
      } else if(type === 'brandType') {
        this.brandId = 0;
      } else if(type === 'softType') {
        this.softId = 0;
      } else if(type === 'productType') {
        if(fieldName === 'subCatId') {
          this.subCatId = 0;
          this.thirdCatId = 0;
        } else if(fieldName === 'thirdCatId') {
          this.thirdCatId = 0;
        }
        this.fourCatId = 0;
      } else if(type === 'industryType') {
        if(fieldName === 'industryFirstCatId') {
          this.industryFirstCatId = 0;
        }
        this.industrySecordCatId = 0;
      }
    },
    deleteSearchText() {
      this.key = '';
      this.$emit('clear-search');  // 新增这行
      this.getPDFList();
    },
  },
  mounted() {
    let { companyId,searchKey } = this.$route.query;
    this.companyId = companyId;
    this.key = searchKey || '';
    this.getPDFList();
  },
  computed: {
  },
}
</script>
<style scoped>
@import '../style/pdf.css';
.gap {
    height: 36px;
}
.brand_box {
    padding-top: 24px;
    padding-right:-10px;
    font-family: Microsoft YaHei;
    width: 100%;
}
.brand_item {
    float: left;
    line-height: 20px;
    border-bottom: 4px solid #939393;
    cursor: pointer;
    padding: 0 24px;
    margin: 0 1% 10px 0;
    /*width: 424px;*/
    height: 380px;
    background-color: #fff;
    border-bottom: 7px solid #c2c2c2;
    box-sizing: border-box;
    width: 24%;
}
.brand_item:hover {
    border-bottom: 4px solid #7dbd25;
}
.brand_item:hover .brand_operate div p,
.brand_item:hover .brand_operate i {
    color:#7dbd25;
}

.brand_item_img .brand_logo_img {
    width: 90px;
    height: 36px;
    margin: 0 26px 0 auto;
    display: block;
}
.brand_item_img .product_img {
    width: 246px;
    height: 264px;
    margin: 0 auto;
    display: block;
    border: 1px solid #dedede;
}

.brand_operate {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 42px;
    margin-top: 4px;
    text-align: center;
}
.brand_operate div {
    cursor: pointer;
}
.brand_operate i {
    color: #939393;
    font-size: 22px;
    /* width: 24px;
    height: 24px; */
}

.textStyle{
    display: inline-block;
    width: 80px;
    text-align-last: justify;
}

.compatible {
    margin-left: 2px;
}

.notes {
    color: #939393;
    font-size: 12px;
    margin: 0 18px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.notes span {
    margin-right: 5px;
}

.brand_div_title {
    text-overflow: ellipsis;
    overflow: hidden;
    color: #939393;
    font-size: 12px;
    text-align: center;
    height: 24px;
    line-height: 24px;
    margin: 6px auto;
    white-space: nowrap;
    width: 80%;
}

.brand_operate div p {
    color: #939393;
    /* margin-top: 4px; */
    font-size: 12px;
    /* height: 16px; */
    /* line-height: 16px; */
}

.play {
    position: absolute;
    top: 96px;
    left: 96px;
    font-size: 80px;
    color: #d8d7d5;
}

.video_img {
    position: relative;
}

.play_time {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 12px;
    color: #fff;
    background-color: rgba(0,0,0,.5);
    padding: 2px 4px;
}

.type_img_div {
    background-color: #e8e8e8;
    display: flex;
    padding: 10px 10px 0;
    width: 100%;
    box-sizing: border-box;
}

.type_img_block_content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.type_img_block_content img {
    width: 430px;
    height: 261px;
    border: 1px solid #dedede;
}
.type_img_block_content .logo-img {
    width: 108px;
    height: 40px;
    margin-left: auto;
    border: none;
}
.type_img_block_content .logo-img.hide {
    opacity: 0;
}

.type_img_block_title {
    /* display: flex; */
    /* margin: 10px 5px; */
    height: 64px;
    line-height: 64px;
    position: relative;
    font-family: PingFangSC-Regular, PingFang SC;
    text-align: center;
    font-size: 18px;
}
.brand_item:hover {
    border-bottom: 7px solid #205eab;
}
.brand_item:hover .default_bg {
    display: none;
}
.brand_item:hover .active_bg {
    display: block;
}
.type_img_block {
    /* float: left; */
    /* flex: 1; */
    /* padding: 10px 10px 0px 10px; */
    padding: 0 24px;
    margin: 0 2% 10px 0;
    /* width: 424px; */
    height: 306px;
    background-color: #fff;
    border-bottom: 7px solid #c2c2c2;
    box-sizing: border-box;
    width: 23.5%;
}
.type_img_block:nth-last-child(1) {
    margin-right: 0;
}

.type_img_block_title div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 425px;
    font-size: 18px;
    color: #b1b1b1;
}

.type_img_block_title img{
    position: absolute;
    right: -14px;
    bottom: 6px;
    width: 32px;
    height: 20px;
    display: none;
}
.type_img_block_title .default_bg {
    display: block;
}

.pic-item {
    width: 430px;
    height: 261px;
    margin: 0 5px;
}
</style>
